import { render, staticRenderFns } from "./my-invoice.vue?vue&type=template&id=526bd42f&scoped=true"
import script from "./my-invoice.vue?vue&type=script&lang=js"
export * from "./my-invoice.vue?vue&type=script&lang=js"
import style0 from "./my-invoice.vue?vue&type=style&index=0&id=526bd42f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526bd42f",
  null
  
)

export default component.exports